module.exports = __webpack_public_path__ + "media/images/lb/528-7ce4875b2b3186c148181c03a448d3b6.svg";